import Hearder from "../commun/Hearder"
import SideBar from "../commun/SideBar"

export const Report = () => {
    return (
        <>
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className='card'>
                                        <div className="card-header">
                                            <h4 className="card-title mb-0">REPORT</h4>
                                        </div>
                                        <div className='card-body'>
                                            <form>
                                                <div className='d-flex gap-3'>
                                                    <div>
                                                        <label className='form-label'>Booking Date</label>
                                                        <input className='form-control' type='date'
                                                         
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className='form-label'>Guest Name</label>
                                                        <input className='form-control' type='text'
                                                            placeholder='Enter Name'
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className='form-label'>Company Name</label>
                                                        <input className='form-control' type='text' placeholder='Enter Company'
                                                   
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className='form-label'>Check-In</label>
                                                        <input className='form-control' type='date'
                                                    
                                                        />
                                                    </div>

                                                    <div>
                                                        <label className='form-label'>Check-Out</label>
                                                        <input className='form-control' type='date'
                                                           
                                                        />
                                                    </div>

                                                    <div className='text-end' style={{ marginTop: "27px" }}>
                                                        <button className='btn btn-primary me-2' type='button' >
                                                            Filter
                                                        </button>
                                                        <button className='btn btn-danger' type='button' >
                                                            Clear
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
